import CustomInputV2 from "@components/CustomInputV2/CustomInputV2";
import { Checkbox } from "@components/ui/checkbox";
import { Label } from "@components/ui/label";
import { useState } from "react";
import RequirementContextForm from "./RequirementContextForm";

const ManualDraftForm = () => {
  const [isHiringCompanyVisible, setIsHiringCompanyVisible] = useState(true);

  return (
    <>
      {/* Blank Draft */}
      <div className="flex items-center p-5 border rounded-md bg-slate-100 gap-8">
        <span className="uppercase text-xss text-content-muted font-bold shrink-0">
          blank draft
        </span>
        <span className="text-xss font-medium text-light-black">
          <span className="font-semibold text-black">
            You will enter every job-post field manually.
          </span>{" "}
          COMTRACKED will still require structured skills and free-text usage
          context before review.
        </span>
      </div>
      {/* Requirement Context */}
      <RequirementContextForm />
    </>
  );
};

export default ManualDraftForm;
